import { render, staticRenderFns } from "./FIFExpenses.vue?vue&type=template&id=646ec96a&"
import script from "./FIFExpenses.vue?vue&type=script&lang=js&"
export * from "./FIFExpenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports